import { buildImgixImageUrl } from './buildImgixImageUrl';

export const buildCardImageUrl = (url?: string | null): string | undefined =>
  buildImgixImageUrl(url, {
    trim: 'auto',
    fit: 'crop',
    crop: 'top',
    ar: '4:3',
    w: 600,
    q: 70,
  });
